module.exports = __webpack_public_path__ + "img/times.924235f7.svg";